import { Component, ChangeDetectionStrategy } from '@angular/core';

import { ToastService } from './toast.service';
import { ToastKind } from './toast.model';

const COLOR_BY_KIND: Record<ToastKind, string> = {
  success: 'var(--aa-success)',
  warn: 'var(--aa-warning)',
  error: 'var(--aa-danger)',
};

const ICON_BY_KIND: Record<ToastKind, string> = {
  success: '#icon-check',
  warn: '#icon-alert-triangle',
  error: '#icon-alert-circle',
};

@Component({
    selector: 'aa-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ToastComponent {
  readonly toast$ = this.toastService.toast$;

  constructor(private readonly toastService: ToastService) {}

  dismiss(): void {
    this.toastService.dismiss();
  }

  colorFor(kind: ToastKind): string {
    return COLOR_BY_KIND[kind];
  }

  iconFor(kind: ToastKind): string {
    return ICON_BY_KIND[kind];
  }
}
